import { render, staticRenderFns } from "./EditSubmodule.vue?vue&type=template&id=63289c0c&"
import script from "./EditSubmodule.vue?vue&type=script&lang=ts&"
export * from "./EditSubmodule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports